module.exports = __webpack_public_path__ + "vn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vn.svg
// module id = 1139
// module chunks = 0